export const staffEnvironment = {
  beta: true,
  production: false,
  apiUrl: 'https://beta.api.petszel.com/',
  bgNavColor: '#A7E4FF'
};